module.exports = __webpack_public_path__ + "media/top/about_lifereechintai-c27a2cf5.svg";